function isMobileLayout() {
    return window.innerWidth < 768;
}

module.exports = isMobileLayout;



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/helpers/04_isMobileLayout.js